import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const authData = useSelector(state => state?.login?.data);
  const location = useLocation();

  const isTokenValid = (token) => {
    try {
      if (!token) return false;

      const decoded = jwtDecode(token);
      if (!decoded?.exp) return false;

      return decoded.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  };

  const isAuthenticated =
    authData?.token && isTokenValid(authData.token);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role check (only enforced when the route explicitly passes
  // allowedRoles — routes with no restriction just need to be logged in).
  // Login payload shape differs by role today: ADMIN login stores a flat
  // `role` field on authData directly, while some other flows nest it
  // under authData.user.role — checking both rather than assuming one.
  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = authData?.role || authData?.user?.role;
    if (!userRole || !allowedRoles.includes(userRole)) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
